import './App.scss';
import { AppState, GameService, SFSConnectionStatus, appActions } from './slices/appSlice';
import { BridgeWarAvatar } from './assets/bridgewars/avatars';
import { FooterComponent } from './features/footer-component/footer-component';
import { LoadingComponent } from './features/loading-component/loading-component';
import { RootComponent } from './features/root-component/root-component';
import { bridgeWarAssets } from './assets/bridgewars';
import { bridgeWarGui, environment } from './env';
import { classNames } from './utils/mixed';
import { useAppDispatch, useAppSelector } from './app/hooks';
import AudreyGameEngineInterface from './app-interfaces/game-engine-interface.audrey.class';
import React, { CSSProperties, Suspense, useEffect } from 'react';
import SharkGameEngineInterface from './app-interfaces/game-engine-interface.shark.class';

const urlHasParams = window.location.href.indexOf('?') !== -1;
const urlParamsString = urlHasParams ? window.location.href.substring(window.location.href.indexOf('?') + 1) : '';
const searchParams = new URLSearchParams(urlParamsString);

const _urlParams: Record<string, string> | undefined = [...searchParams.entries()].reduce<AppState['urlParams']>(
    (cumulated, current) => {
        return { ...cumulated, [current[0]]: current[1] };
    },
    {},
);
const _service: GameService = _urlParams?.['service'] as GameService;

function App() {
    const { urlParams, engineState } = useAppSelector((state) => state.app);
    const { seatData } = useAppSelector((state) => state.table);

    const { app_setPID, app_setUrlParams, app_setEngineState } = appActions;
    const dispatch = useAppDispatch();

    const mySeatData = [seatData.top, seatData.right, seatData.bottom, seatData.left].find(
        (_seatData) => _seatData.isMe,
    );

    const avatar: BridgeWarAvatar | undefined = mySeatData?.bridgeWarAvatar
        ? bridgeWarAssets.avatars[mySeatData.bridgeWarAvatar]
        : undefined;

    useEffect(() => {
        dispatch(
            app_setEngineState({
                service: _service,
                sfsHost: _urlParams?.['sfshost']?.toLowerCase(),
                sfsConnectionStatus: _service ? SFSConnectionStatus.disconnected : SFSConnectionStatus.ignore,
            }),
        );
        dispatch(app_setUrlParams(_urlParams));
        dispatch(app_setPID(_urlParams?.['pn']));
    }, []);

    const styles: CSSProperties = {
        '--myBridgeWarBackgroundColor': avatar?.color ?? 'transparent',
    } as CSSProperties;

    return (
        <Suspense fallback="loading">
            <LoadingComponent />
            {urlParams && engineState && (
                <>
                    {_service === 'BetterBridgeClub' ? <AudreyGameEngineInterface /> : <SharkGameEngineInterface />}
                    <div
                        className={classNames('App', environment, bridgeWarGui && 'isBridgeWar', avatar && 'hasAvatar')}
                        style={styles}
                    >
                        <RootComponent />
                        {engineState.service && !bridgeWarGui && <FooterComponent />}
                        {bridgeWarGui && <div className="footer-placeholder" />}
                    </div>
                </>
            )}
        </Suspense>
    );
}

window.addEventListener('resize', () => {
    document.body.style.setProperty('--vw', `${window.innerWidth}px`);
    document.body.style.setProperty('--vh', `${window.innerHeight}px`);
});
document.body.style.setProperty('--vw', `${window.innerWidth}px`);
document.body.style.setProperty('--vh', `${window.innerHeight}px`);

export default App;
